export default __webpack_public_path__ + "static/media/verve.73563224.svg";